<button mat-icon-button [mat-dialog-close]="[]" aria-label="close" (click)="onClosed.emit()" id="full-screen-close-button">
    <mat-icon>close</mat-icon>
</button>
